export const gitCommit = '6eb71c5a'
